//let linklocal = "http://familytree.globalsparks.live/api";
let link = "https://treebackend.globalsparks.live/api";
//let link = "http://127.0.0.1:8000/api";
let paylink = "https://comicskhaya.com/fam/routes/";

const apilink = {
  link,
  paylink,
};

export default apilink;
